const ExternalLink = () => (
  <svg viewBox='0 0 20 20'>
    <path d='M9.168 1.709v1.676a6.668 6.668 0 0 0 .833 13.282 6.668 6.668 0 0 0 6.615-5.833h1.678a8.333 8.333 0 1 1-9.126-9.125Zm7.5 2.803-6.667 6.667L8.823 10l6.667-6.666h-3.822V1.667h6.667v6.667h-1.667V4.512Z' />
  </svg>
)

export { ExternalLink }
